import React from 'react';
import { Badge, Box, Text } from '@razorpay/blade/components';
import { EmployeeFieldAccess, EmployeeFieldAccessRole } from '../../../types';
import { PermissionRow } from '../../../styles';
import { AccessControl } from './AccessControl';

const getMemberCountLabel = (memberCount: number) => {
  if (memberCount === 0) return 'no members';
  return `${memberCount} ${memberCount === 1 ? 'member' : 'members'}`;
};

type RolePermissionsPanelProps = {
  roles: EmployeeFieldAccessRole[];
  resolvedAccessPolicy: Record<number, EmployeeFieldAccess>;
  openAccessRoleId: number | null;
  onAccessMenuToggle: (roleId: number) => void;
  onAccessSelect: (roleId: number, access: EmployeeFieldAccess) => void;
};

export const RolePermissionsPanel = ({
  roles,
  resolvedAccessPolicy,
  openAccessRoleId,
  onAccessMenuToggle,
  onAccessSelect,
}: RolePermissionsPanelProps) => (
  <Box
    position="relative"
    borderWidth="thin"
    borderColor="surface.border.gray.subtle"
    borderRadius="large"
    backgroundColor="surface.background.gray.intense">
    <Box
      display="grid"
      gridTemplateColumns="minmax(0, 1fr) 210px"
      gap="spacing.4"
      padding={['spacing.3', 'spacing.5']}
      backgroundColor="surface.background.gray.subtle"
      borderBottomWidth="thin"
      borderBottomColor="surface.border.gray.subtle">
      <Text size="small" weight="semibold" color="surface.text.gray.muted">
        Role
      </Text>
      <Text size="small" weight="semibold" color="surface.text.gray.muted">
        Access
      </Text>
    </Box>
    {roles.map((role) => (
      <PermissionRow key={role.roleId}>
        <Box>
          <Box display="flex" alignItems="center" gap="spacing.2">
            <Text weight="semibold">{role.name}</Text>
            {role.isCurrentUserRole ? <Badge size="small">You</Badge> : null}
          </Box>
          <Text size="small" color="surface.text.gray.muted">
            {getMemberCountLabel(role.memberCount)}
          </Text>
        </Box>
        <AccessControl
          role={role}
          currentAccess={resolvedAccessPolicy[role.roleId]}
          isOpen={openAccessRoleId === role.roleId}
          onToggle={onAccessMenuToggle}
          onSelect={onAccessSelect}
        />
      </PermissionRow>
    ))}
  </Box>
);
